<div>
  <div class="col-md-12 no-padding">
    <legend>Quotes</legend>

    <ul class="nav nav-tabs" role="tablist">
      <li class="nav-item" [class.active]="currentTab === 'NH3'">
        <a class="nav-link" role="tab" (click)="setTab('NH3')">NH3/LPG Quotes</a>
      </li>
      <li class="nav-item" [class.active]="currentTab === 'Cryo'">
        <a class="nav-link" role="tab" (click)="setTab('Cryo')">Cryo Quotes</a>
      </li>
    </ul>

    <div class="quote-tab-content">
      <div style="margin: 0.75rem 0;">
        <button class="btn btn-primary rate-btn" (click)="exportCurrentGridToExcel()">Export Excel</button>
      </div>

      <p-table
        *ngIf="currentTab === 'NH3'"
        #nh3Table
        [columns]="nh3Columns"
        [value]="nh3Rows"
        sortMode="multiple"
        stateStorage="session"
        stateKey="nh3-quotes-list"
        [scrollable]="true"
        scrollHeight="700px"
      >
        <ng-template pTemplate="colgroup" let-columns>
          <colgroup>
            <col *ngFor="let col of columns" [style.width.px]="col.width" />
          </colgroup>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field">{{ col.header }}</th>
          </tr>
          <tr>
            <th *ngFor="let col of columns">
              <input
                type="text"
                style="width: 100%"
                (input)="$any(nh3Table)?.filter($any($event.target).value, col.field, 'contains')"
                [value]="$any(nh3Table).filters[col.field]?.value"
              />
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rate let-columns="columns">
          <tr class="clickable-row" (dblclick)="onQuoteDoubleClick(rate)">
            <td *ngFor="let col of columns">
              <ng-container *ngIf="col.type === 'currency'; else defaultNh3Cell">
                {{ formatCell(rate, col) | currency }}
              </ng-container>
              <ng-template #defaultNh3Cell>{{ formatCell(rate, col) }}</ng-template>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <p-table
        *ngIf="currentTab === 'Cryo'"
        #cryoTable
        [columns]="cryoColumns"
        [value]="cryoRows"
        sortMode="multiple"
        stateStorage="session"
        stateKey="cryo-quotes-list"
        [scrollable]="true"
        scrollHeight="700px"
      >
        <ng-template pTemplate="colgroup" let-columns>
          <colgroup>
            <col *ngFor="let col of columns" [style.width.px]="col.width" />
          </colgroup>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field">{{ col.header }}</th>
          </tr>
          <tr>
            <th *ngFor="let col of columns">
              <input
                type="text"
                style="width: 100%"
                (input)="$any(cryoTable)?.filter($any($event.target).value, col.field, 'contains')"
                [value]="$any(cryoTable).filters[col.field]?.value"
              />
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rate let-columns="columns">
          <tr class="clickable-row" (dblclick)="onQuoteDoubleClick(rate)">
            <td *ngFor="let col of columns">
              <ng-container *ngIf="col.type === 'currency'; else defaultCryoCell">
                {{ formatCell(rate, col) | currency }}
              </ng-container>
              <ng-template #defaultCryoCell>{{ formatCell(rate, col) }}</ng-template>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
